module.exports = __webpack_public_path__ + "static/media/ipsum_city.eb27e03c.png";